import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-rating-modal',
  templateUrl: './rating-modal.component.html',
  styleUrls: ['./rating-modal.component.scss']
})
export class RatingModalComponent implements OnInit {

  remarks_textbox : any;
  ratingDesc: string = '';
  starRatings: any;
  reviewObj: any = [];
  username:any;
  ReviewsSuccessModal = 'ReviewsSuccessModal'
  ReviewsErrorModal = 'ReviewsErrorModal'
  @Input() assetDetail :any;
  asset_id:number;
  ReviewssuccessPopup: boolean;
  ReviewsErrorPopup : boolean;
  disableSubmit:boolean=true;
  ratingsDefined: boolean;
  previousRatings: any;
  previousComments: any;
  tempremarks_textbox: any;
  successTickImgScr:any;
  failedExcalamImgSrc:any;
  constructor(private router: Router, private _appService : AppService,private activatedRoute: ActivatedRoute) { }
  
  ngOnInit(): void {
    this.successTickImgScr = "./assets/images/green-tick_resize.jpg";
    this.failedExcalamImgSrc = "./assets/images/exclamation_mark_resize.png?0104";
    this._appService.getUsername().subscribe(userdata => this.username = userdata);
    //this.username ="p.p.shrivastava"
    this.remarks_textbox = ''; 
    if(this.assetDetail){
      this.previousRatings = this.assetDetail.Previous_Rating;
      if(this.assetDetail.Comments){
        let userComments = this.assetDetail.Comments.filter((x:any) => x.Name == this.username);
        if(userComments.length > 0){this.remarks_textbox = this.assetDetail.Comments.filter((x:any) => x.Name == this.username)[0].Comments;}}
      this.tempremarks_textbox = this.remarks_textbox;
    }
    if(this.starRatings == undefined){
      this.starRatings = this.previousRatings;
      this.reviewObj.starRatings = this.previousRatings;
    }
  } 
  checkLength(param: any){
    if(param !== undefined){
    return param.length;
  }
  }

  getRatingDetails(event :any){
    this.ratingsDefined = event.disableSubmit;
    this.starRatings = event.rating;
  }

  ngDoCheck(){
    if((this.remarks_textbox?.length == 0 && this.starRatings == undefined) || (this.starRatings == this.previousRatings && this.remarks_textbox == this.tempremarks_textbox)){
      this.disableSubmit = true;
    }
    else this.disableSubmit = false;
  }

  submitReviews(comments:any){
  this.reviewObj.starRatings = this.starRatings;
  this.reviewObj.comments = comments;

  this._appService.addUserRatingComment(this.username,this.assetDetail.Asset_Id,this.reviewObj.starRatings,this.reviewObj.comments).subscribe((res => {
    if(res.errorCode == 202){ this.ReviewsErrorPopup = true}
    else if(res.success == 200){ this.ReviewssuccessPopup = true}
    })
 )

}

modalOkClicked(popupID : any){
if (popupID === 'ReviewssuccessPopup') {
  window.location.reload()
  window.scroll(0, 0);
}
if (popupID === 'ReviewsErrorPopup') {
  window.location.reload()
  window.scroll(0, 0);
}

}

}